/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'backgrounds/phone-frame-gray': {
    width: 16,
    height: 16,
    viewBox: '0 0 388.97 668.19',
    data: '<g data-name="Layer 2"><path pid="0" d="M342.62 0L45.12.46A45.36 45.36 0 000 45.72l.89 577.35a45.36 45.36 0 0045.26 45.12l297.7-.46A45.25 45.25 0 00389 622.47l-.9-577.35A45.65 45.65 0 00342.62 0zM146.21 32.89l95.22-.15a5.43 5.43 0 110 10.86l-95.22.15a5.43 5.43 0 010-10.86zm48.66 612.57a22.5 22.5 0 1122.46-22.53 22.51 22.51 0 01-22.46 22.53zm162.42-61.34l-325 .51-.83-512.58 325-.51z" _fill="#f7f7f7" data-name="Layer 1"/></g>'
  }
})
